import { isEmpty } from '../../_helpers';

export const staticMpas = {
  2: {
    mpa: {
      businessInformation: {
        dbaName: 'DBA Name 3',
        legalBusinessName: 'Invalid Fields *&^*&^',
        preferredMccCode: '5968',
        contactFullName: ' '
      },
      ratesAndFees: {
        statementFee: 50,
        terminalFee: 'cheese'
      }
    },
    fileList: []
  }
};

export const staticAddendums = {
  0: {
    corvia: {
      usingCorviaReserveForm: false
    }
  }
};

export const defaultMockMpaIds = ['0', '1', '2'];

export const mockMpaMetadataList = (options) => {
  const { length = 2, staticMpasFromApp = {} } = options || {};
  const mpaMetadataList =
    !isEmpty(staticMpasFromApp) &&
    Object.keys(staticMpasFromApp).some((k) => !defaultMockMpaIds.includes(`${k}`))
      ? Object.entries(staticMpasFromApp).map(([mpaId, _value], index) =>
          mockMpaMetadata(index, { ...options, mpaId })
        )
      : Array.from({
          length: !isEmpty(staticMpasFromApp) ? Object.values(staticMpasFromApp).length : length
        }).map((item, index) => mockMpaMetadata(index, options));
  return mpaMetadataList;
};

const mockMpaMetadata = (mpaIndex, options) => {
  const { mpaId, staticMpasFromApp, relationship } = options || {};
  const { riskProfile } = relationship || {};
  const mockMpaId = !isEmpty(mpaId) ? mpaId : `${mpaIndex}`;
  const mpaMetadata = {
    applicationMpaId: mockMpaId,
    dbaName: `DBA Name ${mpaIndex + 1} (${riskProfile} risk)`,
    ...staticMpas[mockMpaId], // Default static MPAs for ALL apps
    ...(staticMpasFromApp && staticMpasFromApp[mockMpaId]) // Static MPAs for specific apps
  };
  return mpaMetadata;
};
